import * as React from "react";
import Switch from "@mui/material/Switch";

const CSwitchToggle = ({
  className,
  checked,
  onChange,
  disabled,
  ...props
}) => {
  return (
    <div className={`switch-btn ${className}`}>
      <Switch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
    </div>
  );
};

export default CSwitchToggle;
